"use client";

import { useEffect } from "react";
import { attachDoubleTapContextMenu } from "@/lib/pointer/double-tap-context-menu";

/** Phone double-tap opens the same context menu as a right mouse click. */
export function useDoubleTapContextMenu() {
  useEffect(() => attachDoubleTapContextMenu(document), []);
}
